import { baseURL, useGetQuery } from "api/config";

const API = {
  PRODUCTS: `${baseURL}/api/products/frontend`,
};

export const useProducts = () => useGetQuery("PRODUCTS", API.PRODUCTS);
